<div class="flex justify-center items-center">
  <div class="animate-spin rounded-full border-t-2 border-b-2" [ngClass]="[sizeClass, 'border-' + color]"></div>
</div>
